import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { addInspectionServiceImage } from '../../api/inspection-service.ts';
import { AddInspectionServiceImageRequest } from '../../api/requests/inspection-service-request.ts';

export default function useAddInspectionServiceImage(): UseMutationResult<
  Awaited<ReturnType<typeof addInspectionServiceImage>>,
  Error,
  AddInspectionServiceImageRequest
> {
  return useMutation({
    mutationFn: addInspectionServiceImage,
  });
}
